import * as React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { RootStateType } from "State/Store";
import { getGuidepostAsync } from "State/Guidepost/GuidepostReducer";
import { GuidePostPanel } from "Components/Guidepost/GuidePostPanel";
import { GuidepostDetail } from "Components/Guidepost/GuidepostDetail";
import { Backdrop } from "@material-ui/core";

type Props = {
  handleLogout?: () => void;
};

const StyledWrapper = styled.div`
  width: 50px;
`;

const StyledResponsivePanel = styled.div`
  ${props => props.theme.breakpoints.down("xs")} {
    display: none;
  }
`;

const StyledRecentApplications = styled.div`
  .ibis-guidepost-app {
    margin-left: 0;
  }

  svg {
    width: 28px;
    height: 28px;
  }
`;

export const Guidepost: React.FunctionComponent<Props> = props => {
  const { guidepost, documentation } = useSelector(
    (e: RootStateType) => e.guidepost,
  );
  const dispatch = useDispatch();

  const [detailOpen, setDetailOpen] = React.useState(false);

  React.useEffect(() => {
    let currentUrl = window.location.href;
    dispatch(getGuidepostAsync.request(currentUrl));
  }, [dispatch]);

  return (
    <StyledWrapper className="ibis-guidepost-wrapper">
      <Backdrop open={detailOpen} onClick={() => setDetailOpen} />
      {guidepost && (
        <React.Fragment>
          {detailOpen ? (
            <StyledResponsivePanel>
              <GuidePostPanel
                guidepost={guidepost}
                documentation={documentation}
                setDetailOpen={setDetailOpen}
                handleLogout={props.handleLogout}
              />
            </StyledResponsivePanel>
          ) : (
            <StyledRecentApplications>
              <GuidePostPanel
                guidepost={guidepost}
                documentation={documentation}
                setDetailOpen={setDetailOpen}
                handleLogout={props.handleLogout}
                showTooltips
              />
            </StyledRecentApplications>
          )}

          {detailOpen && (
            <GuidepostDetail
              guidepost={guidepost}
              documentation={documentation}
              setDetailOpen={setDetailOpen}
              handleLogout={props.handleLogout}
            />
          )}
        </React.Fragment>
      )}
    </StyledWrapper>
  );
};
